import { useIntersectionObserver } from 'usehooks-ts';
import VideoViewer from '@/components/common/media-content/video-viewer';
import useConversationStore, { useConversationHandlers } from '@/hooks/conversations/use-conversation-store';
import cn from '@/utils/merge-class-names';
import type { ContentCommonProps } from './content-common-props';
import { MessageQuote } from './message-quote';

type ContentVideoProps = ContentCommonProps & {
  type?: 'quote' | 'clamped';
};

export default function ContentVideo({ message, type }: ContentVideoProps) {
  const { ref, isIntersecting } = useIntersectionObserver({ threshold: 1, freezeOnceVisible: true });
  const { resetSelectedMessages } = useConversationStore();
  const { handleInteraction: onInteraction } = useConversationHandlers();

  const handleViewVideo = () => {
    resetSelectedMessages([message]);
    onInteraction('preview');
  };

  return (
    <div
      ref={ref}
      className={cn('flex flex-col min-h-16 max-h-64 desktop:max-h-112 w-fit max-w-50vw', {
        'max-h-84 desktop:max-h-132 chat-bubble group-data-receiver:chat-bubble-plain group-data-sender:chat-bubble-primary group-data-sender:items-end':
          Boolean(message.Quote),
      })}>
      {message.Quote && (
        <MessageQuote
          className='py-1.5 px-2 mb-1 w-full'
          quote={message.Quote}
        />
      )}

      <div className='relative'>
        <VideoViewer
          isInView={isIntersecting}
          autoPlay={false}
          preload='metadata'
          src={message.Message}
          className='h-full max-h-64 desktop:max-h-112 rounded-lg object-contain'
          controls={!(type !== 'quote')}
        />

        <button
          type='button'
          className='absolute z-20 inset-0 flex flex-col items-center justify-center data-quote:hidden'
          onClick={handleViewVideo}
        />
      </div>
    </div>
  );
}
